<template>
    <div>
        <y-panel-grid :service="$services.Cart.claimGrid" />
    </div>
</template>

<script>

    // Mixins
    import GridPageMixin from '@/mixins/GridPage';

    export default {

        name: 'CartClaimsList',

        mixins: [GridPageMixin],

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.$t('cart.claim.title'),
            };
        },
    };
</script>
